import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RoutePath } from '@common/enums';
import { PageData } from '@common/models';
import { AuthContextService } from '@common/services/auth/auth-context.service';
import { AuthStateService } from '@common/services/auth/auth-state.service';

export const availableServicesGuard: CanActivateFn = (route) => {
  const { serviceType } = (route.data as PageData) ?? {};

  if (serviceType == null) return true;

  return (
    inject(AuthStateService).availableServices()?.includes(serviceType) ||
    inject(Router).createUrlTree([inject(AuthContextService).prefix() + RoutePath.NotFound])
  );
};
